import { ComponentsModule } from "../components/components.module";
import { ServicesModule } from "../services/services.module";
import { AccountModule } from "./account/account.module";
import { AtendimentoModule } from "./atendimento/atendimento.module";
import { CommonModule } from "./common/common.module";
import { HistoricoModule } from "./historico/historico.module";
import { MainComponent } from "./main.component";
import { MaterialThemingConfig } from "./md-theme";
import { ModalModule } from "./modal/modal.module";
import { TEMPLATES } from "./templates";
import {
  naTelaDeLogin,
  sessaoPodeTerTerminado,
  temSessaoNestaAba,
} from "../services/auth/keycloak/keycloak.util";

export const AppModule = "mandaeApp";

angular
  .module(AppModule, [
    "ngCookies",
    "ngResource",
    "ngSanitize",
    "ngMessages",
    "LocalStorageModule",
    "ui.router",
    "ui.bootstrap",
    "ui.utils.masks",
    "idf.br-filters",
    "uiGmapgoogle-maps",
    "ngAnimate",
    "ngStorage",
    "ngFileUpload",
    "credit-cards",
    "ngTable",
    "ui.bootstrap.datetimepicker",
    "addressAutofill",
    "angularMoment",
    "ngMaterial",
    "md.data.table",
    "daterangepicker",
    "mandaeApp.atendimento",
    AccountModule,
    CommonModule,
    ComponentsModule,
    ServicesModule,
    AccountModule,
    AtendimentoModule,
    HistoricoModule,
    ModalModule,
  ])
  .component("appMain", MainComponent)
  .config(MaterialThemingConfig)
  .config(function (
    $urlRouterProvider,
    $locationProvider,
    $httpProvider,
    $urlMatcherFactoryProvider,
    uiGmapGoogleMapApiProvider,
    API_TOKEN,
  ) {
    //enable CSRF
    $httpProvider.defaults.xsrfCookieName = "CSRF-TOKEN";
    $httpProvider.defaults.xsrfHeaderName = "X-CSRF-TOKEN";

    $locationProvider.html5Mode(true);
    $httpProvider.interceptors.push("authInterceptor");

    $httpProvider.defaults.headers.common = {
      "API-TOKEN": API_TOKEN,
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    // se não encontrar a url, redireciona para login
    $urlRouterProvider.otherwise("/login");

    // Google Maps
    uiGmapGoogleMapApiProvider.configure({
      v: "3.17",
      libraries: "weather,geometry,visualization",
    });

    // deixa opcional a barra no fim da url
    $urlMatcherFactoryProvider.strictMode(false);
  })
  .config(function ($mdDateLocaleProvider) {
    $mdDateLocaleProvider.firstDayOfWeek = 1;
    $mdDateLocaleProvider.formatDate = function (date) {
      var m = moment(date);
      return m.isValid() ? m.format("L") : "";
    };
  })

  .run(function (
    $rootScope,
    $state,
    $timeout,
    $transitions,
    Auth,
    ENV,
    VERSION,
    URL,
    PATH,
    URL_SITE
  ) {
    "ngInject";

    $rootScope.alertConnectionProblem = null;
    $rootScope.ENV = ENV;
    $rootScope.VERSION = VERSION;
    $rootScope.URL = URL;
    $rootScope.PATH = PATH;
    $rootScope.URL_SITE = URL_SITE;
    $rootScope.isProgramada = true;
    $rootScope.GMT = new Date().getTimezoneOffset() / 60;
    $rootScope.hideMenu = true;

    $transitions.onBefore({}, function (transition) {
      function ifFinishAccount(obj) {
        return obj.parent && obj.parent.name === "finalizar-cadastro";
      }

      // limpa os alertas do rootScope, se existem.
      if ($rootScope.alerts && $rootScope.alerts.length > 0) {
        $rootScope.alerts = [];
      }

      // A token this tab gave up on (a 401 here) counts as no session, even while other tabs still use it.
      if (temSessaoNestaAba()) {
        // Read before isLoggedInAsync, which ends the session when it is over.
        var podeTerTerminado = sessaoPodeTerTerminado();
        var verificacao = Auth.isLoggedInAsync();

        verificacao.then(function (loggedIn) {
          $rootScope.hideMenu =
            !loggedIn ||
            ifFinishAccount(transition.$to()) ||
            transition.$to().name.indexOf("redirecionar") > -1;

          if (loggedIn && transition.$to().name === "login") {
            $state.go("redirecionar");
          }

          var enableRedirect = {
            importar: [""],
            adicionar: [""],
            "pedido.redirecionar": [""],
            editar: [""],
            "pedido.veiculo": [""],
            "pedido.pagamento": [""],
            "pedido.resumo": [""],
            "pedido.rastreamento": [""],
            documento: [""],
            "gasto-mensal": [""],
            endereco: [""],
            "termos-de-uso": [""],
            "atualizar-termos-de-uso": [""],
          };

          function rulesRoute() {
            return (
              (enableRedirect[transition.$to().name] || []).indexOf(
                transition.$from().name
              ) > -1
            );
          }

          if (rulesRoute()) {
            $state.go("redirecionar");
          }
        });

        // When the check can fail, hold the transition for it: a failed one already sent the browser to
        // the sign-in (isLoggedInAsync), and rendering the page meanwhile only showed it broken, with no
        // user and every call coming back 401.
        if (podeTerTerminado) {
          return verificacao.then(function (loggedIn) {
            if (!loggedIn && !naTelaDeLogin()) {
              return false;
            }
          });
        }
      }
    });

    // change date
    Date.prototype.yyyymmdd = function () {
      var yyyy = this.getFullYear().toString();
      var mm = (this.getMonth() + 1).toString(); // getMonth() is zero-based
      var dd = this.getDate().toString();
      return (
        yyyy +
        "/" +
        (mm[1] ? mm : "0" + mm[0]) +
        "/" +
        (dd[1] ? dd : "0" + dd[0])
      ); // padding
    };

    // change date to return mm/yyy
    Date.prototype.mmyyyy = function () {
      var yyyy = this.getFullYear().toString();
      var mm = (this.getMonth() + 1).toString(); // getMonth() is zero-based
      var dd = this.getDate().toString();

      return [
        yyyy +
          "-" +
          (mm[1] ? mm : "0" + mm[0]) +
          "-" +
          (dd[1] ? dd : "0" + dd[0]),
      ]; // padding
    };

    $rootScope.$on("$includeContentLoaded", function (src) {
      if (angular.element("body").hasClass("smart")) {
        angular.element(".header-page").css("position", "absolute");
        angular.element(".header-page").css("top", "84px");
      }
    });

    $rootScope.closeAlertConnection = function () {
      $rootScope.alertConnectionProblem = null;
    };

    $timeout(function () {
      $rootScope.alertConnectionProblem = null;
    }, 30000);
  });

angular.module(AppModule).run([
  "$templateCache",
  ($templateCache) => {
    TEMPLATES.forEach((t) => $templateCache.put(t.id, t.template));
  },
]);
